<template>
  <section id="hero">

    <b-container>
      <div class="hero-text-container">
        <img src="../assets/img/2017.svg" class="hero-2017-img" alt="2017">
        <h2 class="hero-text">
          Annual and Sustainability Report
        </h2>
      </div>
    </b-container>

    <div class="download-btn-container">
      <a :href="pdfLinks.full"
         class="btn btn-black-trans"
	       target="_blank">
        Download Full Report 2017
        <img src="../assets/img/icons/dl-white.svg" width="17" height="18">
      </a>
    </div>

    <a href="#" class="chevron-down bounce hidden-lg text-decoration-none" v-scroll-to="'#year'"></a>

    <div id="year">
      <scroll-view :offset="100">

        <template slot-scope="visibility">
          <b-container>

            <h3 class="year-headline">
              The year in brief
            </h3>

            <c-numbers key="numbers"
                       :visible="visibility.numbers"/>

            <div class="btn-container">
              <a 	:href="$creo.browserPdfLink(pdfLinks.full, pdfLinks.year, 6)"
	              	class="btn"
		              target="_blank">
                The year in brief
              </a>
            </div>

          </b-container>
        </template>

      </scroll-view>
    </div>

  </section>
</template>

<script>
  import CNumbers from '../components/Numbers.vue';
  import full from '../assets/pdf/full-report.pdf';
  import year from '../assets/pdf/year-in-brief.pdf';

  export default {
    name: 'Hero',
    data() {
      return {
        pdfLinks: {
          'full': full,
          'year': year
        }
      }
    },
    components: {
      CNumbers
    }
  }

</script>



// WEBPACK FOOTER //
// src/sections/Hero.vue